import {getObjectWithLowerCaseKeys} from '../utils/objectUtils';

/**
 * Represents a notification item.
 */
export class Notification {
  /**
   * @param {date} timestamp
   * @param {string} type
   * @param {string} area
   * @param {string} message
   * @param {string} title
   * @param {string} url
   * @param {date} readAt
   * @param {string} jobId
   * @param {string} jobType
   * @param {boolean} triggerDownload
   */
  constructor(
      timestamp = undefined,
      type = undefined,
      area = undefined,
      message = undefined,
      title = undefined,
      url = undefined,
      readAt = undefined,
      jobId = undefined,
      jobType = undefined,
      triggerDownload = false,
  ) {
    this.timestamp = timestamp;
    this.type = type;
    this.area = area;
    this.message = message;
    this.title = title;
    this.url = url;
    this.readAt = readAt;
    this.jobId = jobId;
    this.jobType = jobType;
    this.triggerDownload = triggerDownload;
  }
  
  /**
   * Creates a Notification instance from a raw backend object.
   * Keys are normalized to lowercase.
   *
   * @param obj - Raw notification payload (NotificationDto)
   */
  static from(obj) {
    return Object.assign(new Notification(), getObjectWithLowerCaseKeys(obj));
  }
}